import React, { useEffect } from 'react';
import { u as useInView_2 } from './useInView-CMTI-J0M.js';

var styles = {"trigger":"_3s8-RC5Ky3s-"};

function ComboboxLoadMore({ onLoadMore }) {
    const [inViewRef, isInView] = useInView_2();
    useEffect(() => {
        isInView && onLoadMore();
    }, [isInView]);
    return (React.createElement("div", { "data-testid": "ATL-Combobox-Loadmore-Trigger", ref: inViewRef, className: styles.trigger }));
}

export { ComboboxLoadMore as C };
